<template>
  <div class="page-wrapper">
    <EventStream @tab="switchTab" v-if="tab_switch == 'event_stream' && $checkPermission('event_streaming')">
    </EventStream>
    <TvStream @tab="switchTab" v-if="tab_switch == 'tv_stream' && $checkPermission('tv_streaming')"></TvStream>
    <PastStream @tab="switchTab" v-if="tab_switch == 'past_streaming' && $checkPermission('event_streaming')">
    </PastStream>
    <StreamingLocation @tab="switchTab"
      v-if="tab_switch == 'streaming_location' && $checkPermission('event_streaming')">
    </StreamingLocation>

  </div>
</template>
<script>
import EventStream from "./EventStream.vue";
import PastStream from "./PastStream.vue"
import TvStream from "./TvStream.vue";
import StreamingLocation from "./StreamingLocation.vue";
export default {
  components: {
    EventStream,
    PastStream,
    TvStream,
    StreamingLocation
  },
  data: () => ({
    tab_switch: "event_stream",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "event_stream";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "s_stream", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>
